import axios from 'axios';
import api from 'api';
import {
  setExistingPoliciesCharges,
  setRecommendedPoliciesCharges,
  setPortfolioSplit,
  setPortfolioRiskScore,
  setPastPerformanceAggregates,
  setExistingPoliciesRiskScore,
  setRecommendedPoliciesRiskScore,
  setPastPerformance,
  setTotalOngoingCharges,
  setTotalPerformanceData,
  setAssetAllocations,
  setAggregateDataForPolicies,
  setAssetAllocationEvalue,
  setExistingPoliciesPerformance,
  setSectorBreakdown,
  setCountryBreakdown,
  setRegionalBreakdown,
  setPolicies
} from '..//Case/actions';
import { setExistingPolicies, setRiskSummaries } from '../Case/actions';
import { errHelper } from 'utils';
import { setHasExistingPolicies } from 'store/modules/Case/actions';
import { createAction } from 'redux-starter-kit';
export const SET_DOWNLOAD_TYPE = 'IPS/SET_DOWNLOAD_TYPE';
const setDownloadType = createAction(SET_DOWNLOAD_TYPE);

export const ipsActions = {
  setDownloadType,
  getPastPerformance:
    ({ portfolio }: any) =>
    (dispatch: any) => {
      return Promise.all([
        api.getPastPerformanceAggregateData({ portfolio }),
        api.getTotalPerformanceData({ portfolio })
      ]).then(([pastPerformanceAggregate, totalPerformanceData]) => {
        dispatch(setPastPerformanceAggregates(pastPerformanceAggregate.data));
        dispatch(setTotalPerformanceData(totalPerformanceData.data));
      });
    },

  getDataForPdf2:
    ({ portfolio }: any, individual_policies: boolean, consolidated: boolean) =>
    (dispatch: any) =>
      Promise.all([
        api.getRiskSummaries({ portfolio }),
        api.getPolicies({ portfolio })
      ]).then(([riskSummaries, policies]) => {
        const riskSummary = riskSummaries.data.results[0];
        const { time_horizon_interval, recommended_risk_profile } = riskSummary;
        const policiesId = policies.data.results.map(
          (policy: any) => policy.id
        );

        const arrayOfAggregateCostAndCharges = [];

        if (individual_policies) {
          const policiesData = policiesId.map((id: number) =>
            api.getAggregateCostAndCharges({ portfolio, policyId: id })
          );
          arrayOfAggregateCostAndCharges.push(...policiesData);
        }

        if (consolidated) {
          const consolidatedData = api.getAggregateCostAndCharges({
            portfolio
          });
          arrayOfAggregateCostAndCharges.push(consolidatedData);
        }

        return axios
          .all([
            // api.getExistingPolicies({ portfolio }),
            api.getExistingPoliciesPerformanceData({ portfolio }),
            api.getPastPerformanceAggregateData({ portfolio }),
            // api.getPortfolioSplitData({ portfolio }),
            // api.getExsitinPoliciesChargesData({ portfolio }),
            // api.getRecommendedPoliciesChargesData({ portfolio }),
            // api.getRiskSummaries({ portfolio }),
            // api.getPortfolioRiskScore({ portfolio }),
            // api.getExistingPoliciesRiskScore({ portfolio }),
            // api.getRecommendedPoliciesRiskScore({ portfolio }),
            api.getPastPerformanceData({ portfolio }),
            api.getTotalOngoingCharges({ portfolio }),
            api.getTotalPerformanceData({ portfolio }),
            // api.getAssetAllocationData({ portfolio }),
            // api.getSectorBreakdownData({ portfolio }),
            // api.getRegionalBreakdownData({ portfolio }),
            // api.getCountryBreakdownData({ portfolio }),
            api.getTypicalAssetAllocationEvalue({
              portfolio,
              timeHorizon: time_horizon_interval,
              recommendedRiskProfile: recommended_risk_profile
            }),
            ...arrayOfAggregateCostAndCharges
          ])
          .then(
            axios.spread(
              (
                existingPolicies,
                existingPoliciesPerformance,
                pastPerformanceAggregate,
                portfolioSplit,
                existingPoliciesCharges,
                recommendedPoliciesCharges,
                riskSummaries,
                portfolioRiskScore,
                existingPoliciesRiskScore,
                recommendedPoliciesRiskScore,
                pastPerformanceExisting,
                totalOngoingCharges,
                totalPerformanceData,
                assetAllocations,
                sectorBreakdown,
                regionalBreakdown,
                countryBreakdown,
                assetAllocationsEvalue,
                ...arrayOfAggregateCostAndCharges
              ) => {
                const preparedAggregateCosAndCharges =
                  arrayOfAggregateCostAndCharges.map((responseData: any) => {
                    const url = responseData.request.responseURL;
                    const policyId = url.split('=')[1];

                    return {
                      policyId,
                      data: responseData.data.chart
                    };
                  });
                const isExistigPoliciesExist =
                  existingPolicies.data.results.length > 0;
                dispatch(setPolicies(policies.data));
                dispatch(setExistingPolicies(existingPolicies.data));
                dispatch(
                  setExistingPoliciesPerformance(
                    existingPoliciesPerformance.data
                  )
                );
                dispatch(setHasExistingPolicies(isExistigPoliciesExist));
                dispatch(
                  setPastPerformanceAggregates(pastPerformanceAggregate.data)
                );
                dispatch(setPortfolioSplit(portfolioSplit.data));
                dispatch(
                  setExistingPoliciesCharges(existingPoliciesCharges.data)
                );
                dispatch(
                  setRecommendedPoliciesCharges(recommendedPoliciesCharges.data)
                );
                dispatch(setRiskSummaries(riskSummaries.data));
                dispatch(setPortfolioRiskScore(portfolioRiskScore.data));
                dispatch(
                  setExistingPoliciesRiskScore(existingPoliciesRiskScore.data)
                );
                dispatch(
                  setRecommendedPoliciesRiskScore(
                    recommendedPoliciesRiskScore.data
                  )
                );
                dispatch(setPastPerformance(pastPerformanceExisting.data));
                dispatch(setTotalOngoingCharges(totalOngoingCharges.data));
                dispatch(setTotalPerformanceData(totalPerformanceData.data));
                dispatch(setAssetAllocations(assetAllocations.data));
                dispatch(setSectorBreakdown(sectorBreakdown.data));
                dispatch(setRegionalBreakdown(regionalBreakdown.data));
                dispatch(setCountryBreakdown(countryBreakdown.data));
                dispatch(
                  setAggregateDataForPolicies(preparedAggregateCosAndCharges)
                );
                dispatch(setAssetAllocationEvalue(assetAllocationsEvalue.data));
              }
            )
          )
          .catch((err: any) => {
            errHelper(err);
          });
      })
};
